import React from 'react';

import {FooterModuleStoreButtons} from "../footer-module.store-buttons";
import {FooterModuleSocialButtons} from "../footer-module.social-buttons";
import classNames from "classnames";
import styles from "../../styles/footer.module.scss";

export const FooterModuleDesktopTopButtons = ({controller}) => {
  const {terms} = controller;
  const {GET_COMPLETE_MOBILE_EXPERIENCE, FOLLOW_TW_FOLLOW_BUTTON} = terms;

  return (
    <div className={classNames(styles.top_buttons)}>
      <div className={classNames(styles.top_buttons_title)}>{GET_COMPLETE_MOBILE_EXPERIENCE}:</div>
      <FooterModuleStoreButtons controller={controller}/>
      <div className={classNames(styles.top_buttons_title)}>{FOLLOW_TW_FOLLOW_BUTTON}:</div>
      <FooterModuleSocialButtons controller={controller}/>
    </div>
  );
}
